export const validateLength = (formik, id, value, length) => {
    const val = value.slice(0, length);
    formik.setFieldValue(id, val)
}